import React from 'react';
import { Link } from 'react-router-dom';
import NavigationComponent from '../../commonComponents/util/NavigationComponent';
import HoverTableRow from '../../commonComponents/util/HoverTableRow';
import CampaignStatusTag from '../../commonComponents/shared/CampaignStatusTag';
import { formatDate } from '../../../lib/utils';

export default class CampaignsTableRow extends NavigationComponent {

    render() {
        const { campaignId, status, name, dateCreated, endDate, totalRecipients, totalFunds } = this.props.campaign;
        return (
            <HoverTableRow onClick={this.pushRoute.bind(this, `/campaigns/${campaignId}`)}>
                <td data-label="Status">
                    <CampaignStatusTag status={status} />
                </td>
                <td data-label="Campaign">
                    <Link
                        className="bold-text"
                        to={`/campaigns/${campaignId}`}>
                        {name}
                    </Link>
                </td>
                <td data-label="Date">
                    <p><span className="accent-text">Created: </span>{formatDate(dateCreated)} &nbsp; &nbsp; <span className="accent-text">Ending: </span>{formatDate(endDate)}</p>
                </td>
                <td data-label="Recipients">
                    <p>{totalRecipients}</p>
                </td>
                <td data-label="Campaign Total">
                    <p>{totalFunds}</p>
                </td>
            </HoverTableRow>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/campaignComponents/campaigns/CampaignsTableRow.jsx